import styles from './rectangleAd.module.scss';
import { Grid } from 'antd';
import React, { useMemo } from 'react';
import SquareAd from './SquareAd';
import { useConfig } from 'providers';
const RectangleAd: React.FC = () => {
  const { useBreakpoint } = Grid;
  const { sm } = useBreakpoint();
  const { mdcAccountUrl } = useConfig();
  const manageSubscriptionUrl = useMemo(() => `${mdcAccountUrl}/settings/subscription`, [mdcAccountUrl]);

  if (!sm) {
    return <SquareAd />;
  }

  return (
    <div className={styles.container}>
      <p className={styles.label}>Advertisement</p>

      <div className={styles.content}>
        <p className={styles.desc}>
          Hide ads, help pay for servers & development and unlock Pro only features like, sharing, advanced dashboard,
          extra storage space & more!
        </p>
      </div>
      <a href={manageSubscriptionUrl} className={styles.link}>
        Hide ads
      </a>
    </div>
  );
};

export default RectangleAd;
